import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20illustration%20with%20warm%20coral%20and%20amber%20gradient%20tones%2C%20soft%20flowing%20ink-like%20shapes%20in%20traditional%20East%20Asian%20aesthetic%2C%20delicate%20paper%20texture%20overlay%2C%20dreamy%20ethereal%20atmosphere%2C%20subtle%20golden%20particles%20floating%2C%20clean%20and%20modern%20composition%20with%20negative%20space&width=1600&height=900&seq=hero-bg-comic-01&orientation=landscape"
          alt="琉璃漫站 - 正版漫画在线阅读平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
            正版漫画
            <br />
            <span className="text-primary-400">随时随地</span>畅享阅读
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 leading-relaxed mb-8 max-w-xl">
            琉璃漫站汇聚海量国漫、日漫、韩漫资源，正版授权，高清画质，
            为你打造极致的在线阅读体验。追漫从未如此简单。
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <Link
              to="/category/hot"
              className="px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap"
            >
              立即开始阅读
            </Link>
            <Link
              to="/category/latest"
              className="px-8 py-3.5 rounded-lg bg-background-50/15 text-background-50 backdrop-blur-sm font-semibold text-base hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap border border-background-50/20"
            >
              查看最新更新
            </Link>
          </div>

          {/* Stats */}
          <div className="flex items-center gap-8 mt-12">
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">10,000+</p>
              <p className="text-sm text-background-50/60 mt-1">正版漫画</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</p>
              <p className="text-sm text-background-50/60 mt-1">活跃读者</p>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div>
              <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">99.9%</p>
              <p className="text-sm text-background-50/60 mt-1">高清画质</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}